import React from 'react';

// --------------------------------------------------------------------------------
// 1. VISTA PENDIENTE (EL PEDIDO LLEGA DE LINA)
// --------------------------------------------------------------------------------
function VistaPendiente({ envio, onAceptarRechazar }) {
    const nombre = envio.envio?.nombre || envio.cliente_nombre || 'Sin nombre';
    const direccion = envio.envio?.direccion || envio.direccion || 'Sin dirección';
    const telefono = envio.envio?.telefono || envio.telefono || 'Sin teléfono';
    const resumenPedido = envio.resumen || (envio.productos ? 'Pedido de Lina' : 'Sin detalles');

    return (
        <div className="card bg-danger text-white shadow-sm mb-3 border-0">
            <div className="card-body">
                <h5>
                    <i className="bi bi-cart-check me-2"></i> 
                    Pedido #{envio.pedido_id ? envio.pedido_id.toString().substring(0, 8) : '---'}
                </h5>
                <div className="mb-3">
                    <p className="mb-1"><strong>Cliente:</strong> {nombre}</p>
                    <p className="mb-1 small"><i className="bi bi-geo-alt-fill me-1"></i> {direccion}</p>
                    <p className="mb-1 small"><i className="bi bi-telephone-fill me-1"></i> {telefono}</p>
                    <hr className="my-2" style={{ opacity: 0.5, borderColor: 'white' }} />
                    <p className="mb-0 small"><strong>Resumen:</strong> {resumenPedido}</p>
                </div>

                <div className="d-flex gap-2">
                    <button 
                        className="btn btn-success btn-sm fw-bold w-100 shadow-sm" 
                        onClick={() => onAceptarRechazar(envio, 'aceptar')}
                    >
                        ✅ Aceptar Pedido
                    </button>
                    <button 
                        className="btn btn-outline-light btn-sm" 
                        onClick={() => onAceptarRechazar(envio, 'rechazar')}
                    >
                        ❌
                    </button>
                </div>
            </div>
        </div>
    );
}

// --------------------------------------------------------------------------------
// 2. VISTA EN PROCESO (FLUJO DUAL: ADMIN + CLIENTE) - RESTAURADA
// --------------------------------------------------------------------------------
function VistaEnProceso({ envio, onIniciarRuta, onBridgeAction }) {
    const datos = envio.envio || {};
    
    // 1. 💡 SÚPER NORMALIZACIÓN: Buscamos en todas las propiedades posibles
    // Esto asegura que si el Admin manda 'nuevo_estatus_bridge' o 'estado_bridge', funcione igual.
    const rawEstado = envio.estado_bridge || envio.nuevo_estatus_bridge || 'ESPERANDO_LISTO';
    let estadoBridge = rawEstado.toString().toUpperCase().trim();

    // 2. 💡 SINÓNIMOS: Si el Admin manda "LISTO", lo tratamos como "LISTO_PARA_RECOGER"
    if (estadoBridge === 'LISTO') {
        estadoBridge = 'LISTO_PARA_RECOGER';
    }

    // DEBUG: Para ver en consola qué estado está procesando la tarjeta realmente
    console.log(`[Card Debug] Pedido ${envio.pedido_id}:`, estadoBridge);

    return (
        <div className="card bg-warning text-dark shadow-sm mb-3 border-0">
            <div className="card-body">
                <div className="d-flex justify-content-between align-items-start">
                    <h5 className="fw-bold">
                        <i className="bi bi-truck me-2"></i> 
                        Pedido #{envio.pedido_id?.toString().substring(0, 8)}
                    </h5>
                    <span className="badge bg-dark text-white small">EN TIENDA</span>
                </div>

                <div className="mt-2">
                    <p className="mb-1"><strong>Cliente:</strong> {datos.nombre || envio.cliente_nombre || 'Sin nombre'}</p>
                    <p className="mb-1 small"><i className="bi bi-geo-alt-fill me-1"></i> {datos.direccion || 'Sin dirección'}</p>
                    <hr className="my-2" style={{ borderColor: '#212529', opacity: 0.2 }} />
                </div>

                {/* --- SECCIÓN DEL PUENTE (COMUNICACIÓN CON ADMIN) --- */}
                <div className="bg-white bg-opacity-50 p-2 rounded mb-3 border border-dark border-opacity-10">
                    <p className="small mb-2 fw-bold text-center text-uppercase" style={{fontSize: '11px'}}>Logística de Recogida</p>
                    
                    {/* SPINNER: Solo se muestra si el Admin NO ha avisado */}
                    {estadoBridge === 'ESPERANDO_LISTO' && (
                        <div className="text-center py-2">
                            <div className="spinner-border spinner-border-sm me-2 text-dark" role="status"></div>
                            <span className="small">Esperando preparación de tienda...</span>
                        </div>
                    )}

                    {/* BOTÓN 1: El Admin ya avisó (Señal de Pusher recibida) */}
                    {estadoBridge === 'LISTO_PARA_RECOGER' && (
                        <button 
                            className="btn btn-primary btn-sm w-100 fw-bold mb-1 shadow-sm"
                            onClick={() => onBridgeAction(envio.pedido_id, 'EN_CAMINO_A_TIENDA')}
                        >
                            🚗 Voy para la tienda
                        </button>
                    )}

                    {/* BOTÓN 2: El Repartidor avisó que va en camino */}
                    {estadoBridge === 'EN_CAMINO_A_TIENDA' && (
                        <button 
                            className="btn btn-success btn-sm w-100 fw-bold mb-1 shadow-sm"
                            onClick={() => onBridgeAction(envio.pedido_id, 'EN_TIENDA')}
                        >
                            📍 Ya llegué a la tienda
                        </button>
                    )}

                    {/* ESTADO FINAL DEL PUENTE: Ya tiene el paquete */}
                    {estadoBridge === 'EN_TIENDA' && (
                        <div className="alert alert-success p-1 mb-1 small text-center fw-bold border-success">
                            📦 ¡Pedido en mano!
                        </div>
                    )}
                </div>

                {/* BOTÓN DE ACCIÓN FINAL (BLOQUEADO HASTA TENER EL PAQUETE) */}
                <button 
                    className="btn btn-dark btn-sm w-100 fw-bold shadow-sm py-2" 
                    onClick={() => onIniciarRuta(envio)}
                    disabled={estadoBridge !== 'EN_TIENDA'} 
                >
                    <i className="bi bi-bicycle me-2"></i> INICIAR RUTA DE ENTREGA
                </button>
                
                {estadoBridge !== 'EN_TIENDA' && (
                    <small className="text-muted d-block text-center mt-1" style={{fontSize: '10px'}}>
                        * Debes confirmar recogida en tienda para iniciar ruta
                    </small>
                )}
            </div>
        </div>
    );
}

// --------------------------------------------------------------------------------
// 3. VISTA EN RUTA (COMUNICACIÓN CON EL CLIENTE)
// --------------------------------------------------------------------------------
function VistaEnRuta({ envio, onConfirmarLlegada }) {
    const datos = envio.envio || {};

    return (
        <div className="card bg-info text-white shadow-sm mb-3 border-0">
            <div className="card-body">
                <h5><i className="bi bi-geo-alt-fill me-2"></i> Pedido #{envio.pedido_id?.toString().substring(0,8)}</h5>
                <p className="mb-2 small">
                    <strong>Cliente:</strong> {datos.nombre || envio.cliente_nombre || 'Sin nombre'}<br/>
                    <i className="bi bi-geo-alt-fill me-1"></i> {datos.direccion || 'Sin dirección'}<br/>
                    <i className="bi bi-telephone-fill me-1"></i> {datos.telefono || 'Sin teléfono'}
                </p>
                <div className="d-flex gap-2">
                    <button 
                        className="btn btn-light btn-sm fw-bold w-100 shadow-sm" 
                        onClick={() => onConfirmarLlegada(envio)}
                    >
                        ✅ Confirmar llegada al Cliente
                    </button>
                </div>
            </div>
        </div>
    );
}

// --------------------------------------------------------------------------------
// 4. VISTA EN UBICACIÓN (LLEGADA AL CLIENTE)
// --------------------------------------------------------------------------------
function VistaEnUbicacion({ envio, onConfirmarEntrega }) {
    const datos = envio.envio || {};
    return (
        <div className="card bg-info text-white shadow-sm mb-3 border-0" style={{borderLeft: '5px solid white'}}>
            <div className="card-body">
                <h5><i className="bi bi-geo-alt-fill me-2"></i> Pedido #{envio.pedido_id?.toString().substring(0,8)}</h5>
                <p className="small">
                    <strong>Cliente:</strong> {datos.nombre || envio.cliente_nombre || 'Sin nombre'}<br/>
                    📍 Llegaste al destino. Entrega el paquete.
                </p>
                <button className="btn btn-success btn-sm fw-bold w-100 shadow-sm" onClick={() => onConfirmarEntrega(envio)}>
                    ✅ Finalizar Entrega
                </button>
            </div>
        </div>
    );
}

// --------------------------------------------------------------------------------
// 5. VISTAS FINALES (ENTREGADO / RECHAZADO)
// --------------------------------------------------------------------------------
function VistaFinalizado({ envio }) {
    const datos = envio.envio || {};
    return (
        <div className="card bg-success text-white shadow-sm mb-3 border-0">
            <div className="card-body py-2">
                <p className="mb-0 small text-center">
                    <i className="bi bi-check-circle-fill me-2"></i> 
                    Pedido #{envio.pedido_id?.toString().substring(0,8)} entregado con éxito
                </p>
            </div>
        </div>
    );
}

function VistaRechazado({ envio }) {
    return (
        <div className="card bg-secondary text-white shadow-sm mb-3 border-0">
            <div className="card-body py-2">
                <p className="mb-0 small text-center">❌ Pedido #{envio.pedido_id?.toString().substring(0,8)} rechazado</p>
            </div>
        </div>
    );
}

// ==========================================
// COMPONENTE PADRE PRINCIPAL
// ==========================================
export default function DeliveryCard({
    envio,
    onAceptarRechazar,
    onConfirmarLlegada,
    onConfirmarEntrega,
    onIniciarRuta,
    onBridgeAction // <--- Prop clave para el flujo Admin
}) {
    const estadoActual = (envio.estado || '').toString().toUpperCase().trim();

    switch (estadoActual) {
        case 'ESPERANDO_PRECIO':
        case 'PENDIENTE':
        case 'ASIGNADO_A_DELIVERY':
            return <VistaPendiente envio={envio} onAceptarRechazar={onAceptarRechazar} />;

        case 'ACEPTADO_POR_DELIVERY':
        case 'EN_PROCESO':
        case 'LISTO': 
            return (
                <VistaEnProceso 
                    envio={envio} 
                    onIniciarRuta={onIniciarRuta} 
                    onBridgeAction={onBridgeAction}
                />
            );
        
        case 'EN_RUTA':
            return <VistaEnRuta envio={envio} onConfirmarLlegada={onConfirmarLlegada} />;

        case 'EN_UBICACION':
            return <VistaEnUbicacion envio={envio} onConfirmarEntrega={onConfirmarEntrega} />;

        case 'COMPLETADO_DELIVERY': 
        case 'COMPLETADO':
        case 'CERRADO':
            return <VistaFinalizado envio={envio} />;

        case 'RECHAZADO':
            return <VistaRechazado envio={envio} />;

        default:
            return (
                <div className="card bg-dark text-white mb-3 border-0">
                    <div className="card-body py-2 text-center">
                        <small className="text-muted">Estado: </small>
                        <span className="fw-bold small">{estadoActual || 'VACÍO'}</span>
                    </div>
                </div>
            );
    }
}